import TTrialApplicationInviteUserRegistrationComplete from './index.vue';

TTrialApplicationInviteUserRegistrationComplete.install = app => {
  app.component(TTrialApplicationInviteUserRegistrationComplete.name, TTrialApplicationInviteUserRegistrationComplete);
};

export default TTrialApplicationInviteUserRegistrationComplete;
